/**
 * Reads the CSRF token from meta tags inside a shadow root and returns
 * a headers object ready to spread into fetch() options.
 *
 * @param {ShadowRoot} shadowRoot
 * @returns {Object} e.g. { 'X-CSRF-TOKEN': '<token>' } or {} if no meta found
 */
export function getCsrfHeaders(shadowRoot) {
    const tokenMeta = shadowRoot.querySelector('meta[name="_csrf"]');
    const headerMeta = shadowRoot.querySelector('meta[name="_csrf_header"]');
    if (!tokenMeta) return {};
    const headerName = headerMeta ? headerMeta.getAttribute('content') : 'X-CSRF-TOKEN';
    return { [headerName]: tokenMeta.getAttribute('content') };
}
